import { Tabs as Base } from './Tabs.js';
import { TabPanel } from './TabPanel.js';
export const Tabs = Object.assign(Base, {
    Panel: TabPanel,
});
//# sourceMappingURL=index.js.map